module.exports = __webpack_public_path__ + "img/Weapon_148.735d1f6a.png";